import { render, staticRenderFns } from "./VehicleAssignment.vue?vue&type=template&id=7c6b818e&scoped=true&"
import script from "./VehicleAssignment.vue?vue&type=script&lang=js&"
export * from "./VehicleAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6b818e",
  null
  
)

export default component.exports